export function setInvoiceNumber(type, invoiceNumber) {
    let result = invoiceNumber;
    switch (type) {
        case "customerpayments":
            result = 'PAY-' + result;
            break;
        case "cashadvance":
            break;
        case "emc_apreauth":
            result = 'EMCA-PRE-' + result;
            break;
        case "emc_aother":
            result = 'EMCA-OTH-' + result;
            break;
        case "nspreauth":
            result = 'TRN-' + result;
            break;
        case "sa_training":
            result = 'SATRN-' + result;
            break;
        case "sa_nonwarranty":
            result = 'SANWAR-' + result;
            break;
        case "ns_on_train":
            result = 'OLN-' + result;
            break;
        case "birchwood":
            result = 'BCW-' + result;
            break;
        case "intense":
            result = 'ITS-' + result;
            break;
        default:
            result = invoiceNumber;
            break;
    }
    return result;
}


export function setDescription(type, description){
    let result = '';

    switch (type) {
        case "customerpayments":
            result = 'Customer Payment (Melville)';
            break;
        case "cashadvance":
            break;
        case "emc_apreauth":
            result = 'Pre-authorization Payment';
            break;
        case "emc_aother":
            result = 'Freight or Additional Payment';
            break;
        case "nspreauth":
            result = 'Training Payment';
            break;
        case "sa_training":
            result = 'Training Payment';
            break;
        case "sa_nonwarranty":
            result = 'Non Warranty Payment';
            break;
        case "ns_on_train":
            result = 'Training Payment';
            break;
        case "birchwood":
            result = 'Customer Payment (Birchwood)';
            break;
        case "intense":
            result = 'Customer Payment (Intense)';
            break;
        default:
            result = '';
            break;
    }

    //if($description != null && $description != ''){
    if(description !== null && description !== ''){
        result = `${result} :  ${description}`;
    }

    return result;

}

export function setPaymentReviewTitle(type){
    let result = '';

    switch (type) {
        case "customerpayments":
            result = 'Customer Payment (Melville)';
            break;
        case "emc_apreauth":
            result = 'EMC & A Pre-Authorization Payment';
            break;
        case "emc_aother":
            result = 'EMC & A Freight or Additional Payment';
            break;
        case "nspreauth":
            result = 'Network Solutions Training Payment';
            break;
        case "sa_training":
            result = 'Network Solutions Online Training Payment';
            break;
        case "sa_nonwarranty":
            result = 'Non Warranty Payment';
            break;
        case "ns_on_train":
            result = 'Training Payment';
            break;
        case "birchwood":
            result = 'Customer Payment (Birchwood)';
            break;
        case "intense":
            result = 'Customer Payment (Intense)';
            break;
        default:
            result = 'Customer Payment';
            break;
    }

    return result;

}
